import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store/index";
import { hydrateMerchantContext } from "@/merchant/session";

const { isMerchantContext } = require("@/merchant/access.cjs");
const { getSafeRedirect, isPublicRouteName } = require("./authNavigation.cjs");

Vue.use(VueRouter);

const routes = [
  {
		path: '/',
		name: '',
    redirect: to => {
      return {path:'/home'}
    }
	},
  {
    path: "/login",
    name: "login",

    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/verify",
    name: "verify",
    component: () => import("@/views/Verify/index.vue"),
  },
  {
    path: "/pay/:token",
    name: "securePaymentLink",
    component: () => import("@/views/PaymentLink/index.vue"),
  },
  {
    path: "/assisted-loan/:token",
    name: "assistedLoanHandoff",
    component: () => import("@/views/AssistedLoanHandoff/index.vue"),
  },
  {
    path: "/identificationcode",
    name: "identificationCode",
    component: () => import("@/views/identificationCode/index.vue"),
  },
  {
    path: "/setting/personalinfo",
    name: "personalinfo",
    component: () => import("@/views/Setting/personalInfo.vue"),
  },
  {
    path: "/setting/storeinformation",
    name: "storeInformation",
    component: () => import("@/views/Merchant/storeInformation.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/setting/faq",
    name: "faq",
    component: () => import("@/views/Setting/faq.vue"),
  },
  {
    path: "/setting/rules",
    name: "rules",
    component: () => import("@/views/Rules/index.vue"),
  },
  {
    path: "/setting/contact",
    name: "contact",
    component: () => import("@/views/Setting/contact.vue"),
  },
  {
    path: "/setting/invitepeople",
    name: "invitePeople",
    component: () => import("@/views/Setting/invitePeople.vue"),
  },
  {
    path: "/sendmessage",
    name: "sendMessage",
    component: () => import("@/views/Setting/sendMessage.vue"),
  },
  {
    path: "/validationguide",
    name: "validationGuide",
    component: () => import("@/views/ValidationGuide/index.vue"),
  },
  {
    path: "/challengedetail",
    name: "challengeDetail",
    component: () => import("@/views/Challenge/detail.vue"),
  },
  {
    path: "/storelist/:id",
    name: "storeList",
    component: () => import("@/views/Store/storeList.vue"),
  },
  {
    path: "/storegroup/:id",
    name: "storeGroup",
    component: () => import("@/views/Store/storeGroup.vue"),
  },
  {
    path: "/storelist",
    name: "storeListAll",
    component: () => import("@/views/Store/storeList.vue"),
  },
  {
    path: "/cart/transactions",
    name: "cartTransactions",
    component: () => import("@/views/Cart/transactions.vue"),
  },
  {
    path: "/storedetail/:id",
    name: "storeDetail",
    component: () => import("@/views/Store/storeDetail.vue"),
  },
  {
    path: "/imagegallery/:id",
    name: "imageGallery",
    component: () => import("@/views/Store/imageGallery.vue"),
  },
  {
    path: "/score",
    name: "score",
    component: () => import("@/views/Cart/score.vue"),
  },
  {
    path: "/map",
    name: "showMap",
    component: () => import("@/views/Map/index.vue"),
  },
  {
    path: "/createinvoice",
    name: "createInvoice",
    component: () => import("@/views/Merchant/createInvoice.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/merchant/saleslist",
    name: "salesList",
    component: () => import("@/views/Merchant/salesList.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/merchant/flexible-payments",
    name: "merchantFlexiblePayments",
    component: () => import("@/views/Merchant/lemaCreditSales.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/merchant/barcode",
    name: "merchantBarcode",
    component: () => import("@/views/Merchant/barcodeScanner.vue"),
    meta: { requiresMerchant: true },
  },

  {
    path: "/merchantqrcode/:id",
    name: "merchantQrCode",
    component: () => import("@/views/Merchant/merchantQrCode.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/wallet/lema-credit",
    name: "lemaCreditAccount",
    component: () => import("@/views/LemaCreditAccount/index.vue"),
  },
  {
    path: "/paymentmethod/:layer",
    name: "paymentMethod",
    component: () => import("@/views/UserInvoice/paymentMethod.vue"),
  },
  {
    path: "/barcodepayment/:layer",
    name: "barcodePayment",
    component: () => import("@/views/UserInvoice/barcodePayment.vue"),
  },
  {
    path: "/qrcodescanner/:layer?",
    name: "qrCodeScanner",
    component: () => import("@/views/UserInvoice/qrCodeScanner.vue"),
  },
  {
    path: "/usercreateinvoice/:id/:layer?",
    name: "userCreateInvoice",
    component: () => import("@/views/UserInvoice/createInvoice.vue"),
  },
  {
    path: "/successpurchaseinvoice/:id",
    name: "successPurchaseInvoice",
    component: () => import("@/views/UserInvoice/successPurchaseInvoice.vue"),
  },
  {
    path: "/onlinechat/:id",
    name: "onlineChat",
    component: () => import("@/views/Chat/index.vue"),
  },
  {
    path: "/chathistory",
    name: "chatHistory",
    component: () => import("@/views/Chat/chatHistory.vue"),
  },
  {
    path: "/buylist",
    name: "buylist",
    component: () => import("@/views/Home/buyList.vue"),
  },
  {
    path: "/loan/loanDetail/:id",
    name: "loanDetail",
    component: () => import("@/views/Loan/loanDetail.vue"),
  },
  {
    path: "/loan/selectloan/:id/:loanrequestid?",
    name: "selectLoan",
    component: () => import("@/views/Loan/selectLoan.vue"),
  },
  {
    path: "/loan/subscription/:id",
    name: "loanSubscription",
    component: () => import("@/views/Loan/subscription.vue"),
  },
  {
    path: "/loan/createcase/:id",
    name: "createCase",
    component: () => import("@/views/Loan/createCase.vue"),
  },
  {
    path: "/loan/editcase/:id",
    name: "editCase",
    component: () => import("@/views/Loan/editCase.vue"),
  },
  {
    path: "/loan/accountvalidation/:id",
    name: "accountValidation",
    redirect: to => ({ name: "loanDetail", params: { id: to.params.id } }),
  },
  {
    path: "/loan/blucontract/:id",
    name: "bluContract",
    redirect: to => ({ name: "loanDetail", params: { id: to.params.id } }),
  },
  {
    path: "/loan/submitcheque/:id",
    name: "submitCheque",
    component: () => import("@/views/Loan/submitCheque.vue"),
  },
  {
    path: "/loan/editcheque/:id",
    name: "editCheque",
    component: () => import("@/views/Loan/editCheque.vue"),
  },
  {
    path: "/loan/chequedelivery/:id",
    name: "chequeDelivery",
    redirect: to => ({ name: "loanDetail", params: { id: to.params.id } }),
  },
  {
    path: "/loan/successpayment/:id",
    name: "succesPayment",
    component: () => import("@/views/Loan/successPayment.vue"),
  },
  {
    path: "/loan/failedpayment/:id",
    name: "failedPayment",
    component: () => import("@/views/Loan/failedPayment.vue"),
  },
  {
    path: "/loan/notice/:id",
    name: "notice",
    component: () => import("@/views/Loan/notice.vue"),
  },
  {
    path: "/preregister/:id",
    name: "PreRegister",
    component: () => import("@/views/PreRegister/index.vue"),
  },
  {
    path: "/merchantstore/editstore/:id",
    name: "editStore",
    component: () => import("@/views/Merchant/editStore.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/referreduserloanstatus/",
    name: "ReferredUserLoanStatus",
    component: () => import("@/views/Merchant/referredUserLoanStatus.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/merchantstore/editimagegallery/:id",
    name: "editImageGallery",
    component: () => import("@/views/Merchant/editImageGallery.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/merchantstore/editinformation/:id",
    name: "editInStoreInformation",
    component: () => import("@/views/Merchant/editInformation.vue"),
    meta: { requiresMerchant: true },
  },
  {
    path: "/app",
    name: "layout",
    redirect: "/home",
    component: () => import("@/layout/Layout.vue"),
    // beforeEnter: (to, from, next) => {
    //   let token = Store.state.userConfig.accessToken;
    //   if (token) {
    //     next()
    //   } else {
    //     next({
    //       path: '/login',
    //       replace: true
    //     });
    //   }

    // },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/Home/home.vue"),
      },
      // {
      //   path: "/loan",
      //   name: "loan",
      //   component: () => import("@/views/Home/waiting.vue"),
      // },
      {
        path: "/loan/:jetvamrequest?",
        name: "loan",
        component: () => import("@/views/Home/loan.vue"),
      },
      // {
      //   path: "/home2",
      //   name: "home2",
      //   component: () => import("@/views/Home/index2.vue"),
      // },
      {
        path: "/merchantstore/",
        name: "merchantStore",
        component: () => import("@/views/Merchant/index.vue"),
        meta: { requiresMerchant: true },
      },
      // {
      //   path: "/home3",
      //   name: "home3",
      //   component: () => import("@/views/Home/index-old.vue"),
      // },
      {
        path: "/cart",
        name: "cart",
        component: () => import("@/views/Cart/index.vue"),
      },

      {
        path: "/setting",
        name: "setting",
        component: () => import("@/views/Setting/index.vue"),
      },

      {
        path: "/store",
        name: "store",
        component: () => import("@/views/Store/index.vue"),
      },
      
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const token = store.state.userConfig.accessToken;
  if (token && (to.name === "login" || to.name === "verify")) {
    next(getSafeRedirect(to.query.redirect) || { name: "home" });
    return;
  }
  if (!token && !isPublicRouteName(to.name)) {
    next({ name: "login", query: { redirect: to.fullPath } });
    return;
  }
  if (token && to.matched.some((record) => record.meta.requiresMerchant)) {
    let context = store.state.userConfig.merchantContext;
    if (!context) {
      try {
        context = await hydrateMerchantContext();
      } catch (_) {
        next({ name: "home" });
        return;
      }
    }
    if (!isMerchantContext(context)) {
      next({ name: "home" });
      return;
    }
  }
  next();
});

// router.beforeEach((to, from, next) => {
// 	let token = Store.state.userConfig.accessToken;
// 	if (token) {
// 		if (to.path === '/login' || to.path === '/verify') {
// 			next('/home');
// 		}
// 		next();
// 	} else {

// 		if (to.path !== '/login') {
// 			next('/login');
// 		}
// 		next();
// 	}
// });
// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

export default router;
